import React from 'react';
export function ProblemaSection() {
  return <section aria-labelledby="problema-titulo" className="border-b border-violet-line/40 bg-violet" data-id="element-97" data-mp="1w5pgbr7k13qr">
      <div className="mx-auto max-w-5xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-98" data-mp="1qu0gwci4ylsu">
        <h2 id="problema-titulo" className="max-w-2xl font-serif text-3xl font-medium leading-tight text-bone sm:text-4xl" data-id="element-99" data-mp="1vnv6txoc3x0d">
          El tiempo solo no cura una ruptura
        </h2>
        <div className="mt-8 max-w-reading space-y-6 font-sans text-base font-light leading-relaxed text-bone/75 sm:text-lg" data-id="element-100" data-mp="130ik9ni6bp72">
          <p data-id="element-101" data-mp="1cwtxqgti2l33">
            Seguramente ya te dijeron “dale tiempo al tiempo”. Y es cierto que
            ayuda — pero sin las herramientas correctas, el tiempo solo
            distancia el dolor, no lo resuelve.
          </p>
          <p data-id="element-102" data-mp="2ocio7i5yq28n">
            He visto personas que llevan años cargando el mismo peso, solo que
            más escondido, más disfrazado de “ya lo superé”. Siguen
            desconfiando en sus relaciones nuevas. Siguen repitiendo los mismos
            patrones.
          </p>
          <p className="font-normal text-bone" data-id="element-103" data-mp="39g8aj86rao9h">
            Esto no tiene por qué seguir así.
          </p>
        </div>
      </div>
    </section>;
}